import {
    Autocomplete,
    AutocompleteRenderInputParams, capitalize,
    ListItem,
    ListItemText,
    TextField
} from "@mui/material";
import {FieldProps} from "formik";
import {useMemo, useState} from "react";
import {JobbrancheValues} from "../../models/Jobbranche";

interface BranchenSelectProps extends FieldProps {
    label: string;
    required?: boolean;
    disabled?: boolean;
}

function BranchenSelect({
                            field,
                            form,
                            label,
                            required,
                            disabled,
                        }: BranchenSelectProps) {
    const options = useMemo(() => JobbrancheValues.map((value) => ({
        id: value,
        name: value,
    })), []);

    const selectedOption = options.find(opt => opt.id === field.value) || null;
    const [inputValue, setInputValue] = useState(selectedOption?.name || "");

    return (
        <Autocomplete
            size="medium"
            options={options}
            autoHighlight
            disabled={disabled}
            getOptionLabel={(option) => option.name}
            value={selectedOption}
            inputValue={inputValue}
            onInputChange={(_, value) => setInputValue(value)}
            onChange={(_, newValue) => {
                form.setFieldValue(field.name, newValue ? newValue.id : "");
            }}
            renderOption={(props, option) => (
                <ListItem {...props} key={option.id}>
                    <ListItemText primary={option.name}/>
                </ListItem>
            )}
            renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField
                    {...params}
                    label={label + (required ? " *" : "")}
                    error={!!(form.touched[field.name] && form.errors[field.name])}
                />
            )}
        />
    );
}

export default BranchenSelect;
